import { render, staticRenderFns } from "./ObjecttypeForm.vue?vue&type=template&id=59004b26"
import script from "./ObjecttypeForm.vue?vue&type=script&lang=js"
export * from "./ObjecttypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports